export enum BillingPlanNames {
  FREE = 'free',
  GROWTH_TRIAL = 'growth_trial',
  GROWTH = 'growth',
}
